import React from 'react';
import { AxiosError } from 'axios';
import Modal from '@common/modal';
import { useToast } from '@common/toast';
import { useCancelMatchPosition } from '@repository/match';
import { PositionApplyCancelErrorCode } from '@domain/rs/position/jd/PositionAppyRs';
import { JobApplicationProcessType } from '@domain/constant/jobApplicationProcessType';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';

const cx = classnames.bind(styles);

interface PositionCancelModalProps {
  positionSn?: number;
  visible: boolean;
  onClose: () => void;
  onError: (code: PositionApplyCancelErrorCode) => void;
  setApplyState: (applyState: JobApplicationProcessType | null) => void;
}

const PositionCancelModal = ({ positionSn, visible, onClose, onError, setApplyState }: PositionCancelModalProps) => {
  const Toast = useToast();

  const { mutate: cancelApplication } = useCancelMatchPosition(
    () => {
      Toast({ iconType: 'info', content: '지원이 취소되었습니다.' });
      setApplyState(null);
      onClose();
    },
    (e: AxiosError) => onError(e?.response?.data.errorCode),
  );

  const handleOnClick = () => {
    if (!positionSn) return;
    cancelApplication(positionSn);
  };

  return (
    <Modal visible={visible} dimmed={false}>
      <div className={cx('layer', 'layerCancel')}>
        <em className={cx('title')}>지원을 취소하시겠어요?</em>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'cancel')} role="button" onClick={onClose}>
            아니오
          </a>
          <a className={cx('btn', 'confirm')} role="button" onClick={handleOnClick}>
            네, 취소할게요
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default PositionCancelModal;
